import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Pressable, StyleSheet } from "react-native";
import LinearGradient from 'react-native-linear-gradient';
import { useFontAwesomeIcon } from "../platform";
import { faArrowRight } from "@fortawesome/pro-light-svg-icons";
export const CircleButtonNative = React.memo(function CircleButton(props) {
    const FontAwesomeIcon = useFontAwesomeIcon();
    const colors = React.useMemo(() => (props.color != null ? [props.color, props.color] : ['#ff00ff', '#ff8f00']), [props.color]);
    return (_jsx(Pressable, { onPress: () => props.onClick(), children: _jsx(LinearGradient, { colors: colors, useAngle: true, angle: 90 + 45, angleCenter: { y: 0.5, x: 0.5 }, style: [
                styles.button,
                { borderRadius: props.borderRadius ?? 2000, width: props.size ?? 50, height: props.size ?? 50 },
            ], children: _jsx(FontAwesomeIcon, { icon: props.icon ?? faArrowRight, color: "white", size: (props.size ?? 50) / 2 }) }) }));
});
const styles = StyleSheet.create({
    button: {
        borderRadius: 2000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
